import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import {
  employeeService,
  handoverService
} from "../services/api";

const EmployeeAuthTest = () => {
  const [testResult, setTestResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const testAuth = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Get the token
        const token = localStorage.getItem('employeeToken');
        if (!token) {
          setError('No employee authentication token found in localStorage');
          setLoading(false);
          return;
        }
        
        console.log('Testing authentication with token:', token.substring(0, 15) + '...');
        
        // Test the auth endpoint
        const response = await employeeService.testAuth();
        setTestResult(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Authentication test error:', err);
        setError(err.message || 'Authentication test failed');
        setLoading(false);
      }
    };
    
    testAuth();
  }, []);
  
  return (
    <>
      <Header />
      <div className="container mx-auto px-4 py-16">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">Employee Authentication Test</h1>
        
        {loading ? (
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-900 mx-auto"></div>
        ) : error ? (
          <div className="bg-red-100 text-red-800 p-4 rounded-md mb-6">
            <h2 className="font-bold mb-2">Authentication Error</h2>
            <p>{error}</p>
            <div className="mt-4">
              <p className="font-semibold">Debugging Information:</p>
              <ul className="list-disc ml-5 mt-2">
                <li>Employee Token exists: {localStorage.getItem('employeeToken') ? 'Yes' : 'No'}</li>
                <li>Token begins with: {localStorage.getItem('employeeToken') ? 
                    localStorage.getItem('employeeToken').substring(0, 15) + '...' : 'N/A'}</li>
              </ul>
            </div>
          </div>
        ) : (
          <div className="bg-green-100 text-green-800 p-4 rounded-md mb-6">
            <h2 className="font-bold mb-2">Authentication Successful!</h2>
            <pre className="bg-white p-3 rounded mt-2 overflow-auto text-sm">
              {JSON.stringify(testResult, null, 2)}
            </pre>
          </div>
        )}
        
        <div className="flex space-x-4 mt-8">
          <Link 
            to="/employee/login" 
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          >
            Back to Login
          </Link>
          
          <Link 
            to="/employee/dashboard" 
            className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
          >
            Go to Dashboard
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default EmployeeAuthTest;
